import { createI18n } from 'vue-i18n';
import { storageLocal } from '@pureadmin/utils';
import { systemEnum, Lang } from '@/config';
/* ---------- 自动加载所有 yaml/json ---------- */
// 加载src/locales下的文件
const modules = import.meta.glob('../locales/*.{yaml,yml,json}', {
  eager: true,
  import: 'default',
});

const messages = Object.fromEntries(
  Object.entries(modules).map(([path, v]) => {
    const locale = path.match(/\/([\w-]+)\.(yaml|yml|json)$/)![1];
    return [locale, v];
  })
) as Record<string, any>;
/* ---------- 默认语言：localStorage → zh ---------- */
const defaultLang = (storageLocal().getItem<string>(systemEnum.LOCALE_KEY) as Lang) ?? Lang.LAN_CN;

export const i18n = createI18n({
  legacy: false,
  locale: defaultLang,
  fallbackLocale: Lang.LAN_CN,
  messages,
});
